module.exports = __webpack_public_path__ + "img/card_payment.41e74ba1.svg";